"use client";

import { type ServiceItem, services } from '@/data/servicesListData';
import ServiceCard from '@/components/ServiceCard/ServiceCard';
import { serviceTranslations } from "@/lib/servicesTranslations";
import { useParams } from "next/navigation";

interface ServiceListProps {
  search?: string;
}

export default function ServiceList({ search = '' }: ServiceListProps) {
  const params = useParams();
  const locale = (params?.locale as "pt" | "en") ?? "pt";
  const t = serviceTranslations[locale] ?? serviceTranslations["pt"];

  const filtered = services.filter((service: ServiceItem) => {
    const translatedTitle = t[service.title] ?? service.title;
    return translatedTitle.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
      {filtered.map((service: ServiceItem) => (
        <ServiceCard
          key={service.slug}
          slug={service.slug}
          title={t[service.title] ?? service.title}
          icon={service.icon}
          locale={locale}
        />
      ))}
    </div>
  );
}
